import axios from "axios";

export interface YoutubeGeneratedLink {
  ready: boolean;
  orderId: string;
  link: string;
  expire: string;
}

export const generateYoutubeLink = async (email: string, provider: string | null | undefined): Promise<YoutubeGeneratedLink> => {
  if (!provider?.trim()) {
    throw new Error("링크를 생성하려면 Provider를 먼저 선택해 주세요.");
  }
  try {
    const response = await axios.post<YoutubeGeneratedLink>(
      "/api/ytp/youtube-url/dabomlink",
      { email: email.trim(), provider: provider.trim() },
      { timeout: 150000 },
    );
    const result = response?.data;
    if (!result?.ready || typeof result.link !== "string" || !result.link.trim()) {
      throw new Error("링크가 준비되지 않았습니다. 잠시 후 다시 시도해 주세요.");
    }
    return { ...result, link: result.link.trim() };
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.code === "ECONNABORTED" || error.response?.status === 504) {
        throw new Error("응답 대기 시간이 초과되었습니다. 잠시 후 다시 확인해 주세요.");
      }
      throw new Error("링크 생성에 실패했습니다. 잠시 후 다시 시도해 주세요.");
    }
    throw error;
  }
};
